export const optionsList = (i18n) => {
  const trxOptions = [
    { value: 'new', label: 'Pembuatan passpor baru' },
    { value: 'update', label: 'Perbaharuan passpor' }
  ];

  const genderOptions = [
    { value: 'M', name: i18n('form.gender.male') },
    { value: 'F', name: i18n('form.gender.female') }
  ];

  const marriageOptions = [
    { value: 'SINGLE', name: i18n('form.marriage_status.single') },
    { value: 'MARRIED', name: i18n('form.marriage_status.married') },
    { value: 'DIVORCE', name: i18n('form.marriage_status.divorced') },
    { value: 'DEATH_DIVORCE', name: i18n('form.marriage_status.death_divorced') }
  ];

  const country_options = [
    { value: 'en', label: 'English' },
    { value: 'id', label: 'Indonesia' }
  ];

  const religion_options = [
    { value: 'moslem', label: i18n('form.religion.moslem') },
    { value: 'christian', label: i18n('form.religion.christian') },
    { value: 'budhis', label: i18n('form.religion.budhis') },
    { value: 'hindu', label: i18n('form.religion.hindu') },
    { value: 'khonghucu', label: i18n('form.religion.khonghucu') },
    { value: 'other', label: i18n('form.religion.other') }
  ];

  return {
    trxOptions,
    genderOptions,
    marriageOptions,
    country_options,
    religion_options
  };
};
